import { useEffect, useRef } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { icURL } from "../context/users/DataContextCopy";

/**
 * 디바이스 접속 로그를 관리하는 커스텀 훅
 * - 새 탭/세션 시작 시 1번 호출
 * - 같은 세션에서 새로고침/페이지 이동 시 호출 안 함
 * - 날짜가 바뀌면 다시 호출
 */
const useDeviceLogger = () => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    const logDeviceAccess = async () => {
      // 이미 로그했으면 중복 호출 방지
      if (hasLoggedRef.current) {
        console.log("[DeviceLogger] Already logged in this session, skipping");
        return;
      }

      try {
        // 현재 날짜 (YYYY-MM-DD 형식)
        const today = dayjs().format("YYYY-MM-DD");
        console.log("[DeviceLogger] Today:", today);

        // localStorage에서 마지막 로그 날짜 가져오기 (날짜 기준)
        const lastLogDate = localStorage.getItem("lastDeviceLogDate");
        console.log(
          "[DeviceLogger] Last log date from localStorage:",
          lastLogDate,
        );

        // sessionStorage에서 세션 로그 여부 확인 (탭/세션 기준)
        const sessionLogged = sessionStorage.getItem("deviceLoggedThisSession");
        console.log("[DeviceLogger] Session logged:", sessionLogged);

        // 조건: 날짜가 다르거나 OR 이 세션에서 아직 로그 안 했으면 호출
        if (lastLogDate !== today || !sessionLogged) {
          console.log("[DeviceLogger] Calling API...");

          // 중복 호출 방지 플래그 설정
          hasLoggedRef.current = true;

          // localStorage에 날짜 저장 (날짜 기준)
          localStorage.setItem("lastDeviceLogDate", today);

          // sessionStorage에 세션 로그 표시 (탭 닫으면 자동 삭제됨)
          sessionStorage.setItem("deviceLoggedThisSession", "true");

          console.log(
            "[DeviceLogger] Saved to localStorage and sessionStorage",
          );

          // API 호출
          //   await axios.post(`${icURL}/api/log/insert/device`);
          await axios.get(`${icURL}/mobile/page`);

          console.log("[DeviceLogger] ✅ Device access logged:", today);
        } else {
          console.log(
            "[DeviceLogger] ✅ Already logged (same session and same date)",
          );
        }
      } catch (error) {
        console.error("[DeviceLogger] ❌ Failed to log device access:", error);
        console.error(
          "[DeviceLogger] Error details:",
          error.response?.data || error.message,
        );
        // 에러가 발생해도 storage는 유지 (중복 호출 방지)
        console.log(
          "[DeviceLogger] Error occurred but storage kept to prevent duplicate calls",
        );
      }
    };

    logDeviceAccess();
  }, []); // 컴포넌트 마운트 시 한 번만 실행
};

export default useDeviceLogger;
